module.exports = __webpack_public_path__ + "static/when-prophecy-fails-fb983c959a7e6c4964afc0f340f28e9d.jpg";